import { IGuest } from 'app/shared/model/guest.model';
import { IUser } from 'app/shared/model/user.model';
import { ITopic } from 'app/shared/model/topic.model';
import { IAttachment } from 'app/shared/model/attachment.model';
import { IRecordedMeeting } from 'app/shared/model/recorded-meeting.model';
import { MeetingStatus } from 'app/shared/model/enumerations/meeting-status.model';
import { MeetingType } from 'app/shared/model/enumerations/meeting-type.model';
import { MeetingScope } from 'app/shared/model/enumerations/meeting-scope.model';
import { IMeetingAgenda } from './meeting-agenda.model';

export interface IMeeting {
  id?: number;
  name?: string | null;
  meetingTime?: number | null;
  duration?: number | null;
  statusType?: MeetingStatus | null;
  dailyCoLink?: string | null;
  daliyCoRoom?: string | null;
  type?: MeetingType | null;
  approved?: boolean | null;
  metaData?: string | null;
  meetingScope?: MeetingScope | null;
  guests?: IGuest[] | null;
  user?: IUser | null;
  topics?: ITopic[] | null;
  attachments?: IAttachment[] | null;
  recordedMeeting?: IRecordedMeeting | null;
  meetingAgenda?: IMeetingAgenda | null;
}

export const defaultValue: Readonly<IMeeting> = {
  approved: false,
};
